import { Link } from "../lib/router";
import { useConsent } from "./consent";

const LINKS: [string, string][] = [
  ["/legal/imprint", "Imprint"],
  ["/legal/privacy", "Privacy"],
  ["/legal/terms", "Terms"],
  ["/legal/licence", "Licence (CC BY 4.0)"],
  ["/legal/cookies", "Cookies"],
];

export function Footer() {
  return (
    <footer className="site-footer">
      <nav aria-label="Legal">
        {LINKS.map(([href, label]) => (
          <Link key={href} href={href}>
            {label}
          </Link>
        ))}
        <button
          type="button"
          className="link-button"
          onClick={() => useConsent.getState().openSettings()}
          data-testid="footer-cookie-settings"
        >
          Cookie settings
        </button>
      </nav>
      <p className="muted small">
        All songs are licensed CC BY 4.0 by their contributors. Every sound is synthesised in your browser.
      </p>
    </footer>
  );
}
